import type { ReactElement } from 'react';
import type { BeendeteAbstimmung } from '@mcikm-vote/shared';

import { Karte } from '../../../components/Karte';

/**
 * Abstimmung geschlossen, Ergebnis nicht veröffentlicht (§18.3, §19.2).
 *
 * Ein **neutraler** Hinweis. Er nennt Nummer und Überschrift, damit klar ist, worum es ging — aber
 * keine Zahl, keinen Anteil und keinen Hinweis auf die Verteilung. Ob überhaupt veröffentlicht
 * wird, entscheidet allein der Administrator (§18.3).
 */
export function GeschlossenAnsicht({
  abstimmung,
}: {
  abstimmung: BeendeteAbstimmung;
}): ReactElement {
  const annulliert = abstimmung.status === 'annulliert';

  return (
    <Karte className="text-center">
      <p className="text-text-gedaempft text-sm font-medium">
        Abstimmung {abstimmung.nummer ?? '—'}
      </p>
      <h2 className="mt-1 text-xl font-semibold">{abstimmung.ueberschrift}</h2>

      <p className="mt-4 text-lg font-medium">
        {annulliert ? 'Diese Abstimmung wurde abgebrochen.' : 'Die Abstimmung ist beendet.'}
      </p>

      <p className="text-text-gedaempft mt-2 text-sm">
        {annulliert
          ? 'Es wird kein Ergebnis veröffentlicht. Eine Wiederholung erfolgt gegebenenfalls als neue Abstimmung.'
          : 'Das Ergebnis wurde noch nicht freigegeben. Sobald es veröffentlicht wird, erscheint es hier von selbst.'}
      </p>
    </Karte>
  );
}
